import { isFunction, isNil } from 'swipeclock-frontend';

/**
 * Example:
 * const data = await dispatchAndUnwrap(
 *    dispatch, masterDataApi.endpoints.getMasterDataCompany,
 *    { siteId: user?.site }
 * );
 */

export async function dispatchAndUnwrap(
  dispatch,
  endpoint,
  params,
  forceRefetch = false
) {
  try {
    let response;
    if (isNil(params)) {
      response = dispatch(
        endpoint.initiate(null, { forceRefetch: forceRefetch })
      );
    } else {
      response = dispatch(
        endpoint.initiate(params, { forceRefetch: forceRefetch })
      );
    }
    if (isFunction(response.unsubscribe)) {
      response.unsubscribe();
    }
    return await response.unwrap();
  } catch (error) {
    console.error('Error in dispatchAndUnwrap:', error);
    throw error;
  }
}
